export default {
    CustomerList: {
        ChooseCustomer: 'Valitse asiakas',
    },

    Customer: {
        SafesOnline: 'SafePoint-laitteistot toiminnassa',
        CurrentBalance: 'Nykyinen saldo',
        DailySales: 'Päivän myynti',
        ActiveWarnings: 'Aktiiviset virheet',
        Of: '/',
        In: 'SISÄÄN',
        Branches: 'TOIMIPAIKAT'
    },

    Branch: {
        ExportTransactions: "Hae tapahtumat",
        ManageOperators: "Hallitse käyttäjiä",
        ShowOnMap: "Näytä kartalla",
        CurrentBalance: "Nykyinen saldo",
        DailySales: 'Päivän myynti',
        MainCurrency: 'Päävaluutta',
        TransactionDays: 'Tapahtumat'
    },

    BranchList: {
        Name: 'Nimi',
        Status: 'Tila',
        BalanceAmount: 'Saldo',
        BalanceCurrency: 'Valuutta',
        LastBalance: 'Päivitetty',
        Branches: 'Toimipaikat',
    },

    BranchListFilter: {
        Branches: 'Toimipaikat',
        SearchCriteria: 'Hae toimipaikka...',
    },


    Chart: {
        Sales: 'Myynti',
        Pickup: 'Nouto',
        Balance: 'Saldo',
        Difference: 'Ero',
        Confirmed: 'Vahvistettu',
        SalesBalancesAndPickups: 'Myynnit, saldot ja noudot',
        NoDataAvailable: 'Ei tietoa saatavilla',
        SafebagBalance: 'Turvapussin saldo',
        RecyclableBalance: 'Kierrättävien saldo',
        ManualDepositBalance: 'Manuaalitalletusten saldo',
        OverflowBalance: 'Ylivuodon saldo'
    },

    ChartDenominations: {
        Deposited: 'Talletettu',
        Recyclable: 'Kierrättävä',
        Denominations: 'Rahalaji',
        NoDataAvailable: 'Ei tietoa saatavilla'
    },

    ChartTransactionDay: {
        ProcessedSales: 'Laskettu talletus',
        UnprocessedSales: 'Manuaalitalletus',
        SalesOut: 'Nosto',
        SalesPerHour: 'Myynti tunnissa'
    },

    CustomerHeader: {
        ShowOnMap: 'Näytä kartalla',
        Branches: 'Toimipaikat',
        Branch: 'Toimipaikka',
        ExportTransactions: 'Tapahtumat',
    },

    DeviceStatus: {
        AllOk: 'Kaikki Ok',
    },

    DeviceStatusList: {
        Safes: 'SafePoint',
    },

    ExportForm: {
        ExportTransactions: 'Hae tapahtumat',
        Cancel: 'Peruuta',
        Export: 'Hae',
        FromDate: 'Alkupäivä',
        Time: 'Aika',
        EndDate: 'Loppupäivä'
    },

    ForgotPasswordForm: {
        ForgotHeader: 'Unohditko salasanasi?',
        ForgotText: 'Anna sähköpostiosoitteesi ja paina nappia. Saat sähköpostiisi viestin, jossa ovat lisäohjeet.',
        LoginLink: 'Takaisin sisäänkirjautumiseen',
        EmailAddress: 'Sähköpostiosoite',
        Submit: 'Lähetä sähköposti',
        ErrorMessage: 'Emme voineet lähettää pyyntöäsi palvelimelle'
    },

    LoginPage: {
        LoginHeader: 'Tervetuloa',
        LoginText: 'Kirjaudu sisään sähköpostiosoitteella ja salasanalla',
        LoginForgot: 'Unohditko salasanasi?',
        Username: 'SÄHKÖPOSTI',
        Password: 'SALASANA',
        Login: 'Kirjaudu'
    },

    ResetPasswordPage: {
        ResetHeader: 'Nollaa salasana',
        ResetText: 'Syötä uusi salasanasi.'
    },

    Drawer: {
        Dashboard: 'Ohjausnäkymä',
        SwitchCustomer: 'Vaihda asiakas',
        MyProfile: 'Minun profiili',
        Logout: 'Kirjaudu ulos'
    },

    OperatorForm: {
        UserId: 'Käyttäjätunnus',
        FirstName: 'Etunimi',
        LastName: 'Sukunimi',
        Pin: 'Pin-koodi',
        Save: 'Tallenna',
        Delete: 'Poista',
        Operator: 'Käyttäjä'
    },

    OperatorList: {
        AddOperator: 'Lisää käyttäjä',
        Operators: 'Käyttäjät',
        Name: 'Nimi'
    },

    Profile: {
        Profile: 'Profiili',
        Name: 'Nimi',
        Language: 'Kieli',
        Password: 'Salasana',
        ConfirmPassword: 'Vahvista salasana',
        Update: 'Päivitä'
    },

    ResetPasswordForm: {
        NewPassword: 'Uusi salasana',
        ConfirmPassword: 'Vahvista salasana',
        Submit: 'Tallenna'
    },

    InviteUserForm: {
        InviteHeader: 'Käyttäjä kutsuttu',
        InviteText: 'Täytä profiilitietosi ja paina Tallenna -nappia kirjautuaksesi sisään',
        Name: 'Nimi',
        Language: 'Kieli',
        NewPassword: 'Uusi salasana',
        ConfirmPassword: 'Vahvista salasana',
        Submit: 'Tallenna'
    },

    TransactionList: {
        Type: 'Tyyppi',
        Operator: 'Käyttäjä',
        When: 'Milloin',
        Amount: 'Määrä',
        Currency: 'Valuutta',
        Transactions: 'Tapahtumat',
        Device: 'Laite',
        SalesDay: 'Myyntipäivä',
        HoverDeposit: 'Talletus',
        HoverSalesIn: 'Talletus',
        HoverSalesOut: 'Nosto',
        HoverManualDeposit: 'Manuaalinen talletus',
        HoverCollection: 'Nouto',
        HoverCollectionNotes: 'Setelien nouto',
        HoverCollectionCoins: 'Kolikoiden nouto',
        HoverCollectionEnvelope: 'Manuaalisten talletusten nouto',
        HoverCollectionOK: 'Vahvistettu nouto',
        HoverCollectionNotesOK: 'Vahvistettu setelien nouto',
        HoverCollectionCoinsOK: 'Vahvistettu kolikoiden nouto',
        HoverCollectionEnvelopeOK: 'Vahvistettu manuaalisten talletusten nouto',
        HoverCollectionNOK: 'Ero noudossa',
        HoverCollectionNotesNOK: 'Ero setelien noudossa',
        HoverCollectionCoinsNOK: 'Ero kolikoiden noudossa',
        HoverCollectionEnvelopeNOK: 'Ero manuaalisten talletusten noudossa',
        HoverDrain: 'Poisto',
        HoverRefill: 'Täyttö',
        HoverExchange: 'Rahanvaihto',
        HoverExchangeIn: 'Rahanvaihto sisään',
        HoverExchangeOut: 'Rahanvaihto ulos',
        HoverCounterfeit: 'Väärennetty',
        HoverInternal: 'Rahan siirto',
        HoverNOP: 'Ei tapahtumaa'
    },

    TransactionDayList: {
        Date: "Päivä",
        Sales: "Myynti",
        Pickup: "Nouto",
        Balance: "Saldo",
        TransactionDays: "Tapahtuma päivät"
    },

    TransactionDay: {
        Date: "Päivä",
        Sales: "Myynti",
        Pickup: "Nouto",
        Balance: "Saldo",
        TransactionDays: "Tapahtuma päivät",
        ExportTransactions: "Tapahtumat"
    },

    TransactionDatePicker: {
        Date: 'Päivä'
    }
};


// WEBPACK FOOTER //
// ./src/lib/i18n/fi.js